import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import '../../utils/fontawesome'

export default function Skills({ animation, videoDisplay }) {
    // const translateY = useTransform(
    //     scrollYProgress,
    //     [0, 0.4, 0.5, 1],
    //     [0, 0, 700, 50]
    // )
    const translateY = '300px'

    return (
        <>
            {/* <span
                style={{
                    position: `absolute`,
                    top: `300%`,
                    height: `1200px`,
                }}
            /> */}
            <div
                className="slanted"
                style={{
                    position: `absolute`,
                    height: `1200px`,
                    width: `100%`,
                    marginBottom: `-5%`,
                    top: `290%`,
                    background: `-webkit-linear-gradient(to bottom, rgba(115,194,251, 0.25), rgba(100,100,100, 0.25))`,
                    background: `linear-gradient(to bottom, rgba(115,194,251, 0.25), rgba(100,100,100, 0.25))`,
                    display: `flex`,
                    flexDirection: `column`,
                    flexWrap: `wrap`,
                    justifyContent: `center`,
                    alignItems: `center`,
                    padding: `25px`,
                }}
            >
                <div
                    style={{
                        // y: translateY,
                        padding: '20px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        flexDirection: 'column',
                        height: `100%`,
                        width: `100%`,
                    }}
                >
                    <div
                        className={
                            animation ? (!videoDisplay ? `firstRow` : ``) : ``
                        }
                        style={{
                            display: `flex`,
                            justifyContent: `space-evenly`,
                            alignItems: `center`,
                            width: `100%`,
                            height: `220px`,
                        }}
                    >
                        <div
                            className="boxsizing"
                            style={{
                                height: `150px`,
                                width: `150px`,
                                borderRadius: `20px`,
                                border: `2px solid rgba(0,0,0,0)`,
                                display: `flex`,
                                flexDirection: `column`,
                                justifyContent: `center`,
                                alignItems: `center`,
                                padding: '22px',
                                color: `white`,
                                backgroundColor: `rgba(0,0,0,0.5)`,
                            }}
                        >
                            <FontAwesomeIcon
                                className={animation ? `sillyhover` : ``}
                                style={{ height: `100%`, width: `100%` }}
                                size={`lg`}
                                icon={[`fab`, `react`]}
                            />
                        </div>
                        <div
                            className="boxsizing"
                            style={{
                                height: `150px`,
                                width: `150px`,
                                borderRadius: `20px`,
                                border: `2px solid rgba(0,0,0,0)`,

                                display: `flex`,
                                flexDirection: `column`,
                                justifyContent: `center`,
                                alignItems: `center`,
                                padding: '22px',
                                color: `white`,
                                backgroundColor: `rgba(0,0,0,0.5)`,
                            }}
                        >
                            <svg
                                className={animation ? `sillyhover` : ``}
                                style={{ height: `80%`, width: `80%` }}
                                width="64"
                                height="64"
                                viewBox="0 0 64 64"
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M57.143 32h-16v4.57h10.97c-1.6 6.857-6.63 12.57-13.257 14.857L12.57 25.143c2.743-8 10.514-13.714 19.43-13.714 6.857 0 13.03 3.43 16.914 8.686l3.43-2.97C47.77 10.97 40.457 6.857 32 6.857c-11.886 0-21.943 8.457-24.457 19.657l30.17 30.17c10.97-2.743 19.43-12.8 19.43-24.686zm-50.286.23c0 6.4 2.514 12.57 7.314 17.37s11.2 7.314 17.37 7.314z"
                                    fill="none"
                                />
                                <path
                                    fill="white"
                                    d="M32 0C14.4 0 0 14.4 0 32s14.4 32 32 32 32-14.4 32-32S49.6 0 32 0zM14.17 49.83c-4.8-4.8-7.314-11.2-7.314-17.37L31.77 57.143c-6.4-.23-12.8-2.514-17.6-7.314zm23.314 6.63L7.543 26.514C10.057 15.314 20.114 6.857 32 6.857c8.457 0 15.77 4.114 20.343 10.286l-3.43 2.97C45.03 14.857 38.857 11.43 32 11.43c-8.914 0-16.457 5.714-19.43 13.714L38.857 51.43c6.63-2.286 11.657-8 13.257-14.857h-10.97V32h16c0 11.886-8.457 21.943-19.657 24.457z"
                                />
                            </svg>
                        </div>
                        <div
                            className="boxsizing"
                            style={{
                                height: `150px`,
                                width: `150px`,
                                borderRadius: `20px`,
                                border: `2px solid rgba(0,0,0,0)`,

                                display: `flex`,
                                flexDirection: `column`,
                                justifyContent: `center`,
                                alignItems: `center`,
                                padding: '22px',
                                color: `white`,
                                backgroundColor: `rgba(0,0,0,0.5)`,
                            }}
                        >
                            <svg
                                className={animation ? `sillyhover` : ``}
                                style={{ height: `120%`, width: `120%` }}
                                width="207px"
                                height="124px"
                                viewBox="0 0 207 124"
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    fill="white"
                                    d="M48.9421964,32.6320058 L87.9011585,32.6320058 L87.9011585,35.7136421 L52.5134345,35.7136421 L52.5134345,58.9070103 L85.7908813,58.9070103 L85.7908813,61.9886466 L52.5134345,61.9886466 L52.5134345,87.4526941 L88.306981,87.4526941 L88.306981,90.5343303 L48.9421964,90.5343303 L48.9421964,32.6320058 Z M91.3912326,32.6320058 L95.5306221,32.6320058 L113.8738,58.0960534 L132.622801,32.6320058 L158.124498,0.286809811 L116.22757,60.7722112 L137.817329,90.5343303 L133.51561,90.5343303 L113.8738,63.4483691 L94.1508254,90.5343303 L89.9302715,90.5343303 L111.682358,60.7722112 L91.3912326,32.6320058 Z M139.359455,35.713642 L139.359455,32.6320058 L183.756439,32.6320058 L183.756439,35.7136421 L163.302983,35.7136421 L163.302983,90.5343303 L159.731745,90.5343303 L159.731745,35.7136421 L139.359455,35.713642 Z"
                                    id="EXT"
                                ></path>
                                <polygon
                                    fill="white"
                                    id="Type-something"
                                    points="0.202923647 32.6320058 4.66697141 32.6320058 66.2235778 124.303087 40.785176 90.5343303 3.93649086 37.0111732 3.77416185 90.5343303 0.202923647 90.5343303"
                                ></polygon>
                                <path
                                    fill="white"
                                    d="M183.396622,86.5227221 C184.134938,86.5227221 184.673474,85.9601075 184.673474,85.233037 C184.673474,84.5059658 184.134938,83.9433513 183.396622,83.9433513 C182.666993,83.9433513 182.11977,84.5059658 182.11977,85.233037 C182.11977,85.9601075 182.666993,86.5227221 183.396622,86.5227221 Z M186.905793,83.1297235 C186.905793,85.2763149 188.460599,86.678523 190.727662,86.678523 C193.142388,86.678523 194.601647,85.233037 194.601647,82.7229099 L194.601647,73.8855335 L192.655968,73.8855335 L192.655968,82.7142542 C192.655968,84.1078073 191.952397,84.8521899 190.710289,84.8521899 C189.598473,84.8521899 188.842785,84.1597409 188.816727,83.1297235 L186.905793,83.1297235 Z M197.146664,83.0172011 C197.285642,85.2503478 199.153145,86.678523 201.932686,86.678523 C204.903321,86.678523 206.762139,85.1811034 206.762139,82.792155 C206.762139,80.9138876 205.702439,79.8752151 203.131364,79.2779777 L201.750279,78.9404092 C200.117298,78.5595622 199.457158,78.0488813 199.457158,77.1573541 C199.457158,76.0321243 200.482113,75.296398 202.019547,75.296398 C203.478806,75.296398 204.48639,76.0148135 204.668797,77.1660091 L206.562359,77.1660091 C206.44944,75.0626962 204.590622,73.5825873 202.045605,73.5825873 C199.309495,73.5825873 197.48542,75.0626962 197.48542,77.2871878 C197.48542,79.1221767 198.519063,80.2127835 200.786126,80.7407758 L202.401734,81.1302779 C204.060773,81.5197807 204.790402,82.091051 204.790402,83.0431676 C204.790402,84.1510859 203.643842,84.9560573 202.08035,84.9560573 C200.403939,84.9560573 199.240006,84.2030196 199.074971,83.0172011 L197.146664,83.0172011 Z"
                                    id=".JS"
                                ></path>
                            </svg>
                        </div>
                        <div
                            className="boxsizing"
                            style={{
                                height: `150px`,
                                width: `150px`,
                                borderRadius: `20px`,
                                border: `2px solid rgba(0,0,0,0)`,

                                display: `flex`,
                                flexDirection: `column`,
                                justifyContent: `center`,
                                alignItems: `center`,
                                padding: '22px',
                                color: `white`,
                                backgroundColor: `rgba(0,0,0,0.5)`,
                            }}
                        >
                            <FontAwesomeIcon
                                className={animation ? `sillyhover` : ``}
                                style={{ height: `100%`, width: `100%` }}
                                size={`lg`}
                                icon={[`fab`, `node`]}
                            />
                        </div>
                    </div>
                    <div
                        className={
                            animation ? (!videoDisplay ? `secondRow` : ``) : ``
                        }
                        style={{
                            display: `flex`,
                            justifyContent: `space-evenly`,
                            alignItems: `center`,
                            width: `100%`,
                            height: `220px`,
                        }}
                    >
                        <div
                            className="boxsizing"
                            style={{
                                height: `150px`,
                                width: `150px`,
                                borderRadius: `20px`,
                                border: `2px solid rgba(0,0,0,0)`,

                                display: `flex`,
                                flexDirection: `column`,
                                justifyContent: `center`,
                                alignItems: `center`,
                                padding: '22px',
                                color: `white`,
                                backgroundColor: `rgba(0,0,0,0.5)`,
                            }}
                        >
                            <FontAwesomeIcon
                                className={animation ? `sillyhover` : ``}
                                style={{ height: `100%`, width: `100%` }}
                                size={`lg`}
                                icon={[`fab`, `js-square`]}
                            />
                        </div>
                        <div
                            className="boxsizing"
                            style={{
                                height: `150px`,
                                width: `150px`,
                                borderRadius: `20px`,
                                border: `2px solid rgba(0,0,0,0)`,

                                display: `flex`,
                                flexDirection: `column`,
                                justifyContent: `center`,
                                alignItems: `center`,
                                padding: '22px',
                                color: `white`,
                                backgroundColor: `rgba(0,0,0,0.5)`,
                            }}
                        >
                            <FontAwesomeIcon
                                className={animation ? `sillyhover` : ``}
                                style={{ height: `100%`, width: `100%` }}
                                size={`lg`}
                                icon={[`fab`, `html5`]}
                            />
                        </div>
                        <div
                            className="boxsizing"
                            style={{
                                height: `150px`,
                                width: `150px`,
                                borderRadius: `20px`,
                                border: `2px solid rgba(0,0,0,0)`,

                                display: `flex`,
                                flexDirection: `column`,
                                justifyContent: `center`,
                                alignItems: `center`,
                                padding: '22px',
                                color: `white`,
                                backgroundColor: `rgba(0,0,0,0.5)`,
                            }}
                        >
                            <FontAwesomeIcon
                                className={animation ? `sillyhover` : ``}
                                style={{ height: `100%`, width: `100%` }}
                                size={`lg`}
                                icon={[`fab`, `css3-alt`]}
                            />
                        </div>
                        <div
                            className="boxsizing"
                            style={{
                                height: `150px`,
                                width: `150px`,
                                borderRadius: `20px`,
                                border: `2px solid rgba(0,0,0,0)`,

                                display: `flex`,
                                flexDirection: `column`,
                                justifyContent: `center`,
                                alignItems: `center`,
                                padding: '22px',
                                color: `white`,
                                backgroundColor: `rgba(0,0,0,0.5)`,
                            }}
                        >
                            <FontAwesomeIcon
                                className={animation ? `sillyhover` : ``}
                                style={{ height: `100%`, width: `100%` }}
                                size={`lg`}
                                icon={[`fab`, `sass`]}
                            />
                        </div>
                    </div>
                    <div
                        className={
                            animation ? (!videoDisplay ? `thirdRow` : ``) : ``
                        }
                        style={{
                            display: `flex`,
                            justifyContent: `space-evenly`,
                            alignItems: `center`,
                            width: `100%`,
                            height: `220px`,
                        }}
                    >
                        <div
                            className="boxsizing"
                            style={{
                                height: `150px`,
                                width: `150px`,
                                borderRadius: `20px`,
                                border: `2px solid rgba(0,0,0,0)`,

                                display: `flex`,
                                flexDirection: `column`,
                                justifyContent: `center`,
                                alignItems: `center`,
                                padding: '22px',
                                color: `white`,
                                backgroundColor: `rgba(0,0,0,0.5)`,
                            }}
                        >
                            <FontAwesomeIcon
                                className={animation ? `sillyhover` : ``}
                                style={{ height: `100%`, width: `100%` }}
                                size={`lg`}
                                icon={[`fab`, `aws`]}
                                color="white"
                            />
                        </div>
                        <div
                            className="boxsizing"
                            style={{
                                height: `150px`,
                                width: `150px`,
                                borderRadius: `20px`,
                                border: `2px solid rgba(0,0,0,0)`,

                                display: `flex`,
                                flexDirection: `column`,
                                justifyContent: `center`,
                                alignItems: `center`,
                                padding: '22px',
                                color: `white`,
                                backgroundColor: `rgba(0,0,0,0.5)`,
                            }}
                        >
                            <FontAwesomeIcon
                                className={animation ? `sillyhover` : ``}
                                style={{ height: `100%`, width: `100%` }}
                                size={`lg`}
                                icon={[`fab`, `docker`]}
                            />
                        </div>
                        <div
                            className="boxsizing"
                            style={{
                                height: `150px`,
                                width: `150px`,
                                borderRadius: `20px`,
                                border: `2px solid rgba(0,0,0,0)`,

                                display: `flex`,
                                flexDirection: `column`,
                                justifyContent: `center`,
                                alignItems: `center`,
                                padding: '22px',
                                color: `white`,
                                backgroundColor: `rgba(0,0,0,0.5)`,
                            }}
                        >
                            <svg
                                className={animation ? `sillyhover` : ``}
                                style={{ height: `100%`, width: `100%` }}
                                width="64"
                                height="64"
                                version="1.1"
                                viewBox="0 0 64 64"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <radialGradient
                                    id="a"
                                    cx="52.528"
                                    cy="-49.92"
                                    r="104.62"
                                    gradientTransform="matrix(.61175 0 0 .61331 -.13397 -1.3836)"
                                    gradientUnits="userSpaceOnUse"
                                >
                                    <stop stopColor="#000" offset="0" />
                                    <stop stopColor="#fff" offset="1" />
                                </radialGradient>
                                <path
                                    d="m46.346483 22.20967-.02321-.0098c-.01346-.0052-.0267-.0098-.03835-.02177-.03876-.04166-.05599-.09901-.04666-.155232l1.288391-7.888348 6.041941 6.052296-6.283618 2.677296c-.01712.0071-.03618.01058-.05501.0098h-.025c-.0083-.0052-.01654-.01173-.03331-.02837-.233859-.260748-.513499-.476295-.825047-.635942zm8.763733-.480712 6.460298 6.469578c1.341723 1.345328 2.013422 2.016323 2.258434 2.79414.0367.115188.06666.230336.09001.348851l-15.439039-6.548031c-.0083-.0035-.01654-.0069-.025-.0098-.06166-.02502-.133344-.05339-.133344-.116842 0-.06343.07332-.09349.134979-.118496l.02004-.0083zm8.545393 11.688978c-.333351.627596-.983385 1.278559-2.083429 2.38186l-7.283669 7.292465-9.420428-1.964573-.04999-.0098c-.08336-.01346-.171676-.02837-.171676-.103475-.07234-.786678-.467735-1.507918-1.091714-1.99128-.03835-.03839-.02835-.09847-.01654-.153559 0-.0083 0-.01654.0033-.02346l1.771746-10.8928.0065-.03674c.0098-.08347.025-.180273.100013-.180273.766976-.09555 1.463541-.495445 1.933423-1.109976.015-.01654.02498-.03506.045-.04508.05331-.02504.116669 0 .171676.02346l16.084087 6.813416zm-11.042176 11.351811-11.977209 11.994429 2.050094-12.618685.0033-.01654c.0017-.01654.0052-.03337.0098-.04841.01654-.04006.06001-.05676.101667-.07345l.02002-.0083c.448883-.191794.84589-.48755 1.158387-.862945.04001-.04674.08834-.0918.15-.100166.01596-.0027.03233-.0027.04833 0l8.433719 1.735903zm-14.512327 14.53319-1.350059 1.352001-14.925683-21.601991c-.0054-.0079-.01096-.01558-.01654-.02346-.02322-.03174-.04833-.06343-.04335-.100167 0-.02671.01846-.05006.03668-.07009l.01654-.02173c.04501-.0668.08336-.133537.124997-.205313l.03333-.05843.0052-.0052c.02346-.04006.04501-.07847.08499-.100167.03499-.01654.08336-.0098.121689-.0017l16.535752 3.415063c.04624.0071.08984.02618.126671.05508.02173.02175.0267.04508.03168.0718.233801.885914.867675 1.611464 1.713412 1.961238.04666.02346.0267.07511.0052.13019-.01077.02419-.01931.04929-.025.07511-.208342 1.268543-1.99509 12.181373-2.47511 15.127403zm-2.820128 2.822516c-.995044.986459-1.581739 1.508897-2.245103 1.719205-.654068.207123-1.35602.207123-2.010091 0-.776702-.247032-1.448397-.918024-2.790126-2.263342l-14.98902-15.010569 3.915183-6.08067c.01846-.03004.03668-.05676.06666-.07847.04164-.03004.101667-.01654.151673 0 .898641.271506 1.863491.22254 2.730124-.138537.04501-.01654.09001-.02837.124997.0033.01769.01577.03316.03391.04666.05339l14.99902 21.79728zm-23.479403-17.001849-3.4384886-3.443431 6.7903076-2.900963c.01731-.0077.03606-.01154.05501-.01173.05666 0 .09001.05676.120015.108476.06824.105129.150499.207586.216674.30712l.02173.02671c.02004.02837.0065.05676-.01346.08347l-3.750174 5.830301zm-4.9602256-4.967355-4.350199-4.356453c-.7400331-.741094-1.2767249-1.27856-1.65007505-1.740912l13.22726765 2.747403c.01654.0031.03327.006.05001.0083.08168.01346.171657.02839.171657.105167 0 .08347-.09834.121843-.181677.153558l-.03833.01654zm-6.76030785-8.337349c.015137-.280634.065482-.558237.1499963-.826224.2466782-.777817.91670935-1.448812 2.26010255-2.79414l5.566918-5.574918c2.5631736 3.725316 5.1332976 7.445831 7.7103536 11.161527.04501.06009.09499.126862.04335.176927-.243354.26873-.48669.562497-.658366.881304-.01866.04097-.04729.07659-.08336.103494-.02173.01346-.045.0083-.06999.0033h-.0033l-14.91570445-3.132937zm9.46709585-10.687493 7.4820096-7.496101c.705029.30879 3.266814 1.392059 5.555252 2.360159 1.733411.734426 3.313486 1.402077 3.810175 1.619067.04999.02004.09499.04004.116669.09013.01346.03004.0065.06843 0 .100167-.240693 1.099159.08691 2.245842.871707 3.051184.04999.05008 0 .121824-.04335.18362l-.02321.03506-7.600348 11.789126c-.02002.03337-.03833.06176-.07168.08347-.04.02504-.09669.01346-.143346.0017-.295603-.07755-.599489-.119034-.905042-.123516-.273343 0-.570023.05008-.870037.105149h-.0017c-.03333.0052-.06334.01173-.09001-.0083-.02946-.0242-.05478-.05283-.07499-.08513l-8.0136786-11.705671zm8.9970776-9.01001 9.690443-9.7043713c1.341729-1.343658 2.013424-2.01631995 2.790126-2.26168495.654071-.207121 1.356023-.207121 2.010091 0 .776704.245365 1.4484.91802695 2.790129 2.26168495l2.100095 2.103114-6.891981 10.6891623c-.01693.03112-.04031.05837-.06834.08011-.04166.02837-.100013.01654-.150019 0-1.103143-.335253-2.300409-.104206-3.200147.617581-.04501.04674-.111649.02004-.168329-.0052-.900039-.392246-7.900357-3.354968-8.902072-3.780596zm20.844283-6.1357563 6.363626 6.3727713-1.533406 9.510752v.02504c-.0013.02173-.006.04303-.01346.06343-.01654.03337-.04999.04006-.08336.05008-.32785.09946-.636627.253495-.913374.455673-.01192.0087-.02296.01808-.03333.02837-.01846.02004-.03668.03837-.06666.04172-.02443.000732-.04876-.0031-.07168-.01173l-9.697109-4.12611-.01846-.0083c-.06166-.02502-.135017-.0551-.135017-.118497-.05701-.541158-.233484-1.062847-.51669-1.52726-.04668-.07678-.09834-.156925-.05835-.23534zm-6.553632 14.3646063 9.090415 3.855712c.04999.02347.105014.04506.12667.0968.0088.03114.0088.06401 0 .09515-.02669.133536-.04999.285425-.04999.438986v.255377c0 .06343-.06501.09013-.124997.115188l-.01846.0065c-1.440067.615949-20.217592 8.634491-20.245929 8.634491-.02833 0-.05833 0-.08666-.02837-.04999-.05006 0-.120189.04501-.18362.0081-.01096.01558-.02223.02322-.03337l7.47034-11.583823.01346-.02002c.04335-.07009.09334-.148557.173331-.148557l.07501.01173c.170003.02346.320013.04504.471688.04504 1.133385 0 2.183434-.552481 2.816795-1.497213.01519-.02525.03422-.0478.05666-.0668.04501-.03337.111668-.01654.163329.0065zm-10.410472 15.331041 20.467595-8.741278s.02998 0 .05833.02837c.111669.111842.206681.186928.298345.257049l.04501.02837c.04164.02346.08336.05006.08665.09349 0 .01654 0 .02671-.0035.04172l-1.753415 10.785971-.0065.04341c-.01173.08347-.02322.178619-.101667.178619-.949053.06416-1.805362.593165-2.288438 1.41376l-.0083.01346c-.02322.03841-.04501.07511-.08336.09515-.03499.01654-.07999.0098-.116669.0017l-16.322383-3.371708c-.01654-.0033-.253346-.866281-.271677-.86795z"
                                    fill="url(#a)"
                                />
                            </svg>
                        </div>
                        <div
                            className="boxsizing"
                            style={{
                                height: `150px`,
                                width: `150px`,
                                borderRadius: `20px`,
                                border: `2px solid rgba(0,0,0,0)`,

                                display: `flex`,
                                flexDirection: `column`,
                                justifyContent: `center`,
                                alignItems: `center`,
                                padding: '22px',
                                color: `white`,
                                backgroundColor: `rgba(0,0,0,0.5)`,
                            }}
                        >
                            <svg
                                className={animation ? `sillyhover` : ``}
                                style={{ height: `80%`, width: `80%` }}
                                width="64"
                                height="64"
                                viewBox="0 0 64 64"
                                preserveAspectRatio="xMinYMin meet"
                                version="1.1"
                                viewBox="0 0 5.12 5.12"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M4.12 5.12H.968a.49.49 0 0 1-.488-.488V.488A.49.49 0 0 1 .968 0H4.12a.49.49 0 0 1 .488.488v4.144a.49.49 0 0 1-.488.488z"
                                    fill="none"
                                />
                                <path
                                    d="M3.068 4.415V2.382s.132-.487-1.63.2C1.436 2.6 1.436.7 1.436.7L2.01.697v1.2s1.61-.635 1.61.48v2.026h-.555zm.328-2.986h-.6c.22-.27.42-.73.42-.73h.63s-.108.3-.44.73zm-1.95 2.982V3.254l.58.58-.58.58z"
                                    fill="white"
                                />
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
